/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateWhatsAppMarkAllAsReadPathParams,
	CandidateWhatsAppMarkAllAsReadResponse,
} from '../types/CandidateWhatsAppMarkAllAsRead'

/**
 * POST /candidates/:candidateId/whatsapp/read-all
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::markAllAsRead
 */
export async function candidateWhatsAppMarkAllAsRead(
	candidateId: CandidateWhatsAppMarkAllAsReadPathParams['candidateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateWhatsAppMarkAllAsReadResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/whatsapp/read-all`, undefined, config)
}
